export class CacheHelper {
    public static getWithExpiry(key: string) {
        const itemJSON: string = localStorage.getItem(key);

        if (!itemJSON) {
            return null;
        }

        const item: any = JSON.parse(itemJSON);
        const now: Date = new Date();

        if (now.getTime() > item.expiry) {
            localStorage.removeItem(key);
            return null;
        }

        return item.value;
    }

    public static setWithExpiry(key: string, value: any, expireInHours: number) {
        const now: Date = new Date();
        const item: any = {
            value: value,
            expiry: now.getTime() + (expireInHours * 60 * 60 * 1000)
        };

        localStorage.setItem(key, JSON.stringify(item));
    }
}